import { Build } from "~/components/build/Show/lib/types";
import { queryOptions, UseQueryOptions } from "@tanstack/react-query";
import fetcher from "~/components/build/Show/lib/fetcher";

export type BuildFetchMeta = {
  source: string;
  trigger: string;
  delay: number;
};

export const buildQueryKey = (buildId: Build["id"]) => {
  return ["build", buildId];
};

export const buildQueryOptions = (
  buildId: Build["id"],
  buildJsonPath: Build["jsonPath"],
  queryOptionsArgs: Omit<UseQueryOptions<Build>, "queryKey" | "queryFn"> = {},
  getFetchMeta?: () => BuildFetchMeta,
) => {
  return queryOptions({
    queryKey: buildQueryKey(buildId),
    queryFn: ({ signal }) => fetchBuild(buildJsonPath, signal, getFetchMeta?.()),
    ...queryOptionsArgs,
  });
};

function fetchBuild(
  jsonPath: Build["jsonPath"],
  signal: AbortSignal,
  meta?: BuildFetchMeta,
): Promise<Build> {
  const url = new URL(jsonPath, window.location.origin);

  if (meta) {
    url.searchParams.set("source", meta.source);
    url.searchParams.set("trigger", meta.trigger);
    url.searchParams.set("delay", String(meta.delay));
  }

  return fetcher<Build>(url, true, { signal });
}
